import { Button, Autocomplete, TextField, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useState } from "react";

const AddConditioningTestExercise = ({ exerciseList, handleSubmit, handleCancel}) => {

    const [exercise, setExercise] = useState({
        "exercise_id": 1,
        "exercise_type": "standard",
        "metric": "Reps",
        "details": "",
        "reps": 1,
        "weight": 0,
        "duration": 0
    });

    const handleExerciseChange = (e, newValue) => {
        newValue !== null &&
            setExercise({
                ...exercise,
                exercise_id: newValue.id,
                exercise_type: newValue.type
            });
    }

    const handleFieldChange = (fieldName, e) => {
        if (e.target.value === '') {
            setExercise({ ...exercise, [fieldName]: '' });
        } 
        else {
            setExercise({ ...exercise, [fieldName]: e.target.value });
        }
    };

    const preSubmit = () => {
        setExercise((prev) => {
            const finalEx = {
                ...exercise,
                duration: parseFloat(prev.duration),
                weight: parseFloat(prev.weight)
            }

            handleSubmit(finalEx);
            return finalEx
        });

    }

    return (
        <div style={{backgroundColor: 'var(--site-light-background-color)', padding: '0 5px', border: "2px solid grey", borderRadius: '15px', position: 'absolute', top: '0', bottom: '10%', margin:'auto 0', height: 'fit-content', width: '100%', zIndex: '1000'}}>
            <h2 className="h2-style">Add Exercise</h2>

            <Autocomplete style={{marginTop: '10px'}} 
                options={exerciseList} 
                getOptionLabel={option => option.name} 
                isOptionEqualToValue={() => true}
                value={exerciseList.filter(ex => ex.id === exercise.exercise_id)[0]}
                onChange={handleExerciseChange}
                renderInput={(params) => (
                    <TextField {...params} label={"Search or select an exercise"} variant="outlined" />
                )}
            />

            <FormControl fullWidth style={{marginTop: '10px'}}>
                <InputLabel id="metric-type-label">Test Metric</InputLabel>
                <Select
                    labelId="metric-type-label"
                    label="Test Metric"
                    id="metric-type"
                    value={exercise.metric}
                    onChange={e => handleFieldChange('metric', e)}
                >                    
                    <MenuItem value={'Reps'}>Total Reps</MenuItem>
                    <MenuItem value={'Duration'}>Hold</MenuItem> 
                    <MenuItem value={'Speed'}>Speed</MenuItem>
                    <MenuItem value={'Weight'}>Max Weight</MenuItem>
                </Select>
            </FormControl>

            <TextField fullWidth style={{ marginTop: "10px" }}
                type="text"
                id="test-details"
                label="Test Details e.g. max in 30 seconds"
                variant="outlined"
                value={exercise.details}
                onChange={e => handleFieldChange('details', e)}
            />

            <div className='bottom-buttons'>
                <Button
                    style={{margin: "15px 5px 5px", width: '100px'}}
                    disabled={!exercise.details?.length}
                    onClick={preSubmit}
                    variant="contained"
                >
                    Add
                </Button>

                <Button
                    style={{margin: "15px 5px 5px", width: '100px'}}
                    onClick={handleCancel}
                    variant="contained"
                >
                    Cancel
                </Button>
            </div>
        </div>
    )
}

export default AddConditioningTestExercise;